/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { defaultsDeep, identity, map } from 'lodash';
import { t } from '@lingui/macro';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { LegacyIcon } from '../../icon';
import { ENTITY_TYPES } from '../../../services/EntityService';

export const filterId = 'Agent';
export const filterTitle = t`nPoint`;
export const entityType = ENTITY_TYPES.AGENT;

export function useAgent() {
    return useEntity(filterId);
}

export function useAgentName() {
    return useEntityName(filterId);
}

function sitesFormatter(value) {
    return map(value, 'name').join(', ');
}

const dataSourceParams = {
    entityFields: ['name', 'sites.name'],
};

const columns = [
    {
        type: COLUMN_TYPES.ICON,
        title: t`Type`,
        width: 74,
        icons: [
            {
                getIcon: (row) => <LegacyIcon icon={row?.typeIcon} />,
            },
        ],
    },
    {
        title: t`Name`,
        mapping: 'name',
        flex: 1,
        minWidth: 250,
        sortable: true,
        resizable: false,
    },
    {
        title: t`Site`,
        minWidth: 200,
        flex: 1,
        sortable: true,
        mapping: 'sites',
        formatter: sitesFormatter,
        resizable: false,
    },
];

function AgentFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType, columns, dataSourceParams, showHeaders: true };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

AgentFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

AgentFilter.defaultProps = defaultsDeep(
    {
        options: {
            link: {
                target: '/agent-detail',
                mappedFilterParams: {
                    [filterId]: identity,
                },
            },
        },
        id: filterId,
        title: filterTitle,
        state: undefined,
        maxWidth: 'md',
        fullWidth: true, // TODO: something going on with DataTable makes this necessary for 'md' size to actually be bigger
    },
    EntityListFilter.defaultProps
);

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType),
})(AgentFilter);
